import styles from './PriceBox.module.css';

interface PriceBoxProps extends React.HTMLAttributes<HTMLDivElement> {}

const PriceBox = ({ className, ...props }: PriceBoxProps): React.JSX.Element => (
    <div className={`${styles.priceBox}${className ? ` ${className}` : ''}`} {...props} />
);

export { PriceBox };
